export default "__VITE_ASSET__Da5KWtdl__"